export default __webpack_public_path__ + "static/media/HurricaneSwap_icon@2x.02d7fad5.png";